import { B3SelectItem } from 'src/app/shared/models/b3-select-item.model';
import { OperationType } from 'src/app/shared/interfaces/operation-type.enum';

export const OPERATION_TYPE_BY_CODE: Record<number, OperationType> = {
  1: OperationType.DEPOSIT,
  2: OperationType.TRANSFER_WITHOUT_FINANCIAL,
  3: OperationType.WITHDRAW,
  4: OperationType.DELIVERY,
  5: OperationType.TRADE_FROM,
  6: OperationType.TRADE_TO,
  7: OperationType.RETIREMENT,
  8: OperationType.MINT,
  9: OperationType.TRADE,
};

export const FILTERABLE_OPERATION_TYPES: OperationType[] = [
  OperationType.DEPOSIT,
  OperationType.TRANSFER_WITHOUT_FINANCIAL,
  OperationType.WITHDRAW,
  OperationType.DELIVERY,
  OperationType.TRADE_FROM,
  OperationType.TRADE_TO,
  OperationType.RETIREMENT,
];

export function normalizeOperationTypeForApi(
  value?: B3SelectItem | string | number | null,
): string | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const rawValue = typeof value === 'object' ? value.inputId : value;

  if (rawValue === null || rawValue === undefined || rawValue === '') {
    return undefined;
  }

  const numericCode = Number(rawValue);

  if (!Number.isNaN(numericCode) && OPERATION_TYPE_BY_CODE[numericCode]) {
    return OPERATION_TYPE_BY_CODE[numericCode];
  }

  if (Object.values(OperationType).includes(rawValue as OperationType)) {
    return rawValue as string;
  }

  return undefined;
}

export function normalizeOperationTypeForForm(
  typeCode?: string | number | null,
): string {
  return normalizeOperationTypeForApi(typeCode) ?? '';
}
